import React from "react";

const InfoAboutUs = () => {
  return (
    <div>
      <p>Welcome to the official soccer tote betting site of 4Racing (Pty) Ltd.</p>

      <p>
        Soccer 6 was launched in 2003 and since then has enhanced many soccer fans' enjoyment of the most popular sport on the planet. The phenomenal popularity
        of Soccer 6 resulted in TAB introducing other soccer bets, including Soccer 4, Soccer 10 and Soccer 13, which is hosted by Svenska Spel in Sweden.
      </p>

      <p>
        NOTE: 4Racing (Pty) Ltd and Gold Circle (Pty) Ltd, which operates horseracing and tote betting in KwaZulu-Natal, are the only licensed horseracing and
        tote betting operators in South Africa. 4Racing and Gold Circle commingle all tote or pari-mutuel bets on horseracing and sport in South Africa,
        including Soccer 4, 6, 10 and 13, into single national pools under the TAB banner.{" "}
      </p>
    </div>
  );
};

export default InfoAboutUs;
